import { useData, withDefault } from "@faedev/editor-utils";
import constants from "src/constants";

function getDataProfile(
  slug?: string | null | undefined,
  lang?: string | null | undefined
) {
  return useData(
    () =>
      fetch(`${constants.Paths.apiUrl}/profiles/${slug}`).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("API Error");
        }
      }),
    { _locale: withDefault(lang, constants.Locales._default.lang) }
  );
}

export default getDataProfile;
